export const FETCH_LISTING = "FETCH_LISTING";
export const FETCH_REALTOR = "FETCH_REALTOR";
